import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DirectivesModule } from '../core-ui/Directives/Directives.module';
import { CreatePersonWithBAComponent } from './CreatePersonWithBA.component';

@NgModule({
    imports: [FormsModule, ReactiveFormsModule, CommonModule, DirectivesModule],
    declarations: [CreatePersonWithBAComponent],
    exports: [CreatePersonWithBAComponent],
    providers: []
})
export class CreatePersonWithBAModule {}
